import { CVData } from "./../components/CVContent";
import generatePDF from "./../utils/generateCVPDF";

const CV = () => {
    return (
        <div className="flex flex-col items-center px-4"> {/* Ensures button and CV are centered */}
            <h1 className="mt-20 text-3xl font-bold">CV</h1>
            {/* 📥 PDF Download Button Outside the CV Box */}
            <button
                onClick={generatePDF}
                className="mt-10 mb-6 bg-gray-900 text-white px-6 py-3 rounded-lg hover:bg-gray-700 transition"
            >
                Download CV
            </button>
            {/* 📄 CV Content */}
            <div id="cv-content" className="p-4 border rounded shadow-lg bg-white max-w-3xl mx-auto">

                <h1 className="text-2xl font-bold">{CVData.name}</h1>
                {CVData.profession && <p className="text-gray-700 font-medium">{CVData.profession}</p>}
                <p className="text-sm text-gray-500 mt-1">
                    {CVData.address} &middot; {CVData.phone} &middot;{" "}
                    <a href={`mailto:${CVData.email}`} className="text-blue-500 hover:underline">{CVData.email}</a>
                    {" "}&middot;{" "}
                    <a href={CVData.linkedIn} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">linkedin.com/in/laurence-w-klein</a>
                </p>


                {/* Professional Summary */}
                <h2 id="about" className="mt-10 text-xl font-semibold">Professional Summary</h2>
                <p className="text-gray-600">{CVData.professional_summary}</p>

                {/* Core Strengths */}
                {CVData.core_skills && CVData.core_skills.length ? (
                    <>
                        <h2 id="core-strengths" className="mt-10 text-xl font-semibold">Core Strengths</h2>
                        <ul className="mt-4 list-disc list-inside text-gray-600 space-y-1">
                            {CVData.core_skills.map((skill, index) => (
                                <li key={index}>{skill}</li>
                            ))}
                        </ul>
                    </>
                ) : null}

                {/* Technical Skills */}
                <h2 id="technical-skills" className="mt-16 text-xl font-semibold">Technical Skills</h2>

                <div className="mt-4 space-y-2">
                    {CVData.technical_skills.map((skill, index) => {
                        const [category, ...rest] = skill.split(':');
                        const details = rest.join(':');
                        return (
                            <p key={index} className="text-gray-600">
                                <strong>{category}:</strong>{details}
                            </p>
                        );
                    })}
                </div>


                {/* Professional Experience */}
                <h2 id="projects" className="mt-16 text-xl font-semibold">Professional Experience</h2>
                <div className="space-y-5">
                    {CVData.professional_experience.map((job, index) => (
                        <div key={index}>
                            <h3 className="text-lg font-medium">{job.title} - {job.company}</h3>
                            <p className="text-sm text-gray-500">{job.location} | {job.date}</p>
                            <ul className="list-disc list-inside text-gray-600 mt-2">
                                {job.responsibilities.map((task, taskIndex) => (
                                    <li key={taskIndex}>{task}</li>
                                ))}
                            </ul>
                            {job.highlight ? (
                                <p className="mt-3 text-sm text-gray-700 bg-gray-50 border-l-4 border-blue-400 pl-3 py-2 rounded">{job.highlight}</p>
                            ) : null}
                        </div>
                    ))}
                </div>

                {/* Selected Projects */}
                {CVData.selected_projects && CVData.selected_projects.length ? (
                    <>
                        <h2 id="selected-projects" className="mt-16 text-xl font-semibold">Selected Systems Projects</h2>
                        <div className="space-y-5">
                            {CVData.selected_projects.map((project, index) => (
                                <div key={index}>
                                    <h3 className="text-lg font-medium">{project.name}</h3>
                                    {project.details ? <p className="text-sm text-gray-500">{project.details}</p> : null}
                                    <ul className="list-disc list-inside text-gray-600 mt-2">
                                        {project.responsibilities.map((item, itemIndex) => (
                                            <li key={itemIndex}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </>
                ) : null}


                {/* Education */}
                <h2 id="education" className="mt-16 text-xl font-semibold">Education & Certifications</h2>
                {CVData.education.map((edu, index) => (
                    <div key={index} className="mt-4">
                        <h3 className="text-lg font-medium">{edu.degree}</h3>
                        {edu.institution && <p className="text-sm text-gray-500">{edu.institution}</p>}
                        {edu.relevance && <p className="text-gray-600 mt-1 text-sm">{edu.relevance}</p>}
                    </div>
                ))}




            </div>
        </div>
    );
};

export default CV;
